import moment from 'moment';

export function isSameDay(a, b) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;

  return (
    a.date() === b.date() && a.month() === b.month() && a.year() === b.year()
  );
}

export function formatUserListDate(date) {
  return `${moment(date).format('MM/DD/YY')} (${moment(date).fromNow()})`;
}

export function formatDate(date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function formatCommentDate(date) {
  const standardDate = new Date(date);
  const datePart = standardDate
    .toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })
    .split('/')
    .join(' ');
  const timePart = standardDate.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${datePart} at ${timePart}`;
}

export function customFormatDate(date, format = 'MMMM D, YYYY') {
  return `${moment(date).format(format)}`;
}

export const formatExpiryDate = date => {
  return `${moment(date).format('MM/DD/YYYY')}`;
};

export const formatUserDetailDate = date => {
  return moment(date).format('dddd, MMMM D, YYYY');
};

export const getTimeSince = date => {
  return moment(date)
    .startOf()
    .fromNow();
};



// WEBPACK FOOTER //
// ./src/utils/date.js